import { render } from "./CreateDataset.vue?vue&type=template&id=f577197a"
import script from "./CreateDataset.vue?vue&type=script&lang=js"
export * from "./CreateDataset.vue?vue&type=script&lang=js"

import "./CreateDataset.vue?vue&type=style&index=0&id=f577197a&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__